import { render, staticRenderFns } from "./LatestReviews.vue?vue&type=template&id=4b04fff2&scoped=true&"
import script from "./LatestReviews.vue?vue&type=script&lang=js&"
export * from "./LatestReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b04fff2",
  null
  
)

export default component.exports